import { render } from "./FooterBar.vue?vue&type=template&id=55bfca4c&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=55bfca4c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bfca4c"]])

export default __exports__